import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../../app-ng-material.module';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';
import { GridActionModalComponent } from './components/grid-action-modal/grid-action-modal.component';

@NgModule({
  declarations: [GridActionModalComponent],
  imports: [CommonModule, FormsModule, AppNgMaterialModule, SharedComponentsModule],
  exports: [GridActionModalComponent],
})
export class GridModalsModule {}
